<template>
    <div class='line' :data-word="settingObj.name" >
        <div class='col col1'>
            <a @click='showSetting(settingObj.name)'  :title="'Consulter la configuration '+ settingObj.name">{{ settingObj.name }}</a>
        </div>
        <div class='col col2'>
           {{ getDateTime() }}
        </div>
        <div class='col col4' v-if="showCol4()">
           {{ settingObj.id }}
        </div>

        <button v-if="isSuperAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_editsub btnEdit" @click='clickEditSetting()'>
            <i class="material-icons">edit</i>
        </button>
        <button v-if="isSuperAdmin()" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub btnDelete" @click='clicToDeleteSetting()'>
            <i class="material-icons">delete</i>
        </button>
    </div> 
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums'

    export default { 
        name:"SetttingLine",
        mixins: [FctUtils],
        props:{
            from: {type:String},
            settingObj: {type:Object}, // arrive depuis un vrai <element>
            mode:"",
        },
        methods:{
            isSuperAdmin() {
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            showCol4() {
                return this.isSuperAdmin() && (this.mode == 'liste' || this.mode == 'superadmin' || this.$route.query.mode == 'superadmin')
            },
            showSetting(aDicoName) {
                this.$store.dispatch('chooseSetting', this.settingObj);
                if (this.from != undefined) {
                    this.$router.push({name:this.from, params: {settingProps : JSON.stringify(this.settingObj)} });
                }
                else {
                    this.$router.push({name:"Dicos", params: {settingProps : JSON.stringify(this.settingObj)} });
                }
            },
            getDateTime(){
                var date = new Date(this.settingObj.refresh);

                var formatD = new Intl.NumberFormat('fr-FR', {minimumIntegerDigits:2})

                var result = formatD.format(date.getDate())+ "/" + formatD.format(date.getMonth()+1)+"/"+date.getFullYear()+ " " + formatD.format(date.getHours()) + ":"+formatD.format(date.getMinutes()) ;

                return result
            },
            clicToDeleteSetting() {
                this.emitter.emit('showPLForm', {mode:'formSetting_remove', data:this.settingObj});
            },
            clickEditSetting() {
                this.emitter.emit('showPLForm', {mode:'formSetting_edit', data:this.settingObj});
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnDelete {
    position: absolute;
    top:5px;
    right:5px;
}

.btnEdit {
    position: absolute;
    top:5px;
    right:25px;

    color: #0075bb;
}


</style>
